export const getFabricState = (state) => state.adom.fabric || {};
export const getFabricCustomMenu = (state) =>
  getFabricState(state).fabricCustomMenu;
export const getHasIotEp = (state) => {
  return state.adom.fabricIot.hasIotEp;
};
